"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_admin_1 = require("react-admin");
var RAStyles_1 = require("../common/ReactAdmin/RAStyles");
var react_i18next_1 = require("react-i18next");
var Pagination_1 = __importDefault(require("../common/ReactAdmin/Pagination"));
var styles_1 = require("@mui/material/styles");
var MeatballMenu_1 = __importDefault(require("../common/MeatballMenu"));
var types_1 = require("@/Types/types");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var MetadataDeleteErrorModal_1 = __importDefault(require("../common/MetadataDeleteErrorModal"));
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var material_1 = require("@mui/material");
var TruncatedTextField = function (_a) {
    var dataCy = _a.dataCy, source = _a.source;
    var record = (0, react_admin_1.useRecordContext)();
    var value = record[source] || "";
    return (react_1.default.createElement(material_1.Tooltip, { title: value, arrow: true },
        react_1.default.createElement("span", { className: "truncated-text ns-font-family", "data-cy": dataCy, style: {
                display: "inline-block",
                width: "300px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                verticalAlign: "middle",
                color: "var(--info-color)"
            } }, value)));
};
var MetadataList = function (_a) {
    var onRowClick = _a.onRowClick, permissions = _a.permissions;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _b = (0, react_1.useState)({ message: "", data: [] }), deleteErrorData = _b[0], setDeleteErrorData = _b[1];
    var _c = (0, react_1.useState)(false), showErrorModal = _c[0], setShowErrorModal = _c[1];
    var refresh = (0, react_admin_1.useRefresh)();
    var handleDelete = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.deleteMetadata(id)];
                case 1:
                    response = _c.sent();
                    if (response.status === 200 || response.status === 204) {
                        refresh();
                    }
                    else {
                        if (response.data) {
                            setDeleteErrorData({
                                message: response.data.message,
                                data: (_a = response.data.slides) === null || _a === void 0 ? void 0 : _a.map(function (slide) { return ({
                                    presentation_id: slide.presentation_id,
                                    presentation_title: slide.presentation_title,
                                    type: slide.type,
                                    slide_id: slide.slide_id,
                                    slide_title: slide.slide_title,
                                }); }),
                            });
                            setShowErrorModal(true);
                        }
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    if (error_1.response && error_1.response.data) {
                        setDeleteErrorData({
                            message: error_1.response.data.message,
                            data: (_b = error_1.response.data.slides) === null || _b === void 0 ? void 0 : _b.map(function (slide) { return ({
                                presentation_id: slide.presentation_id,
                                presentation_title: slide.presentation_title,
                                type: slide.type,
                                slide_id: slide.slide_id,
                                slide_title: slide.slide_title,
                            }); }),
                        });
                    }
                    else {
                        setDeleteErrorData({
                            message: "An unexpected error occurred.",
                            data: [],
                        });
                    }
                    setShowErrorModal(true);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onSingleDeleteClick = function (id) {
        handleDelete(id);
    };
    return (react_1.default.createElement("div", { style: { marginTop: "60px", marginLeft: "60px", marginRight: "60px" } },
        react_1.default.createElement(react_admin_1.ListBase, null,
            react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaMetadataDatagridTheme },
                react_1.default.createElement(AccessControl_1.default, { conditionalChildren: [
                        {
                            permission: __spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true),
                            children: (react_1.default.createElement(react_admin_1.Datagrid, { hover: false, sx: RAStyles_1.RaMetadataDataGridSx, bulkActionButtons: false, rowClick: function (_id, _basePath, record) {
                                    onRowClick(record);
                                    return false;
                                } },
                                react_1.default.createElement(react_admin_1.NumberField, { source: "id", label: t("Id"), sortable: false }),
                                react_1.default.createElement(TruncatedTextField, { source: "meta_key", label: t("Metadata"), dataCy: "metaKey", sortable: false }),
                                react_1.default.createElement(TruncatedTextField, { source: "description", label: t("Description"), dataCy: "metaDescription", sortable: false }),
                                react_1.default.createElement(react_admin_1.FunctionField, { render: function (record) { return (react_1.default.createElement(MeatballMenu_1.default, { onEdit: function () { return onRowClick(record); }, resourceId: record.id, type: "Resource", onDelete: function () { return onSingleDeleteClick(record.id); }, resourceType: types_1.ResourceType.METADATA })); } })))
                        },
                        {
                            permission: permissions.read,
                            children: (react_1.default.createElement(react_admin_1.Datagrid, { hover: false, sx: RAStyles_1.RaMetadataDataGridSx, bulkActionButtons: false },
                                react_1.default.createElement(react_admin_1.NumberField, { source: "id", label: t("Id"), sortable: false }),
                                react_1.default.createElement(TruncatedTextField, { source: "meta_key", label: t("Metadata"), dataCy: "metaKey", sortable: false }),
                                react_1.default.createElement(TruncatedTextField, { source: "description", label: t("Description"), dataCy: "metaDescription", sortable: false })))
                        }
                    ] })),
            react_1.default.createElement(Pagination_1.default, null)),
        showErrorModal && (react_1.default.createElement(MetadataDeleteErrorModal_1.default, { isShown: showErrorModal, headerText: t("Unsuccessful deletion of metadata"), onClose: function () { return setShowErrorModal(false); }, message: deleteErrorData.message, data: deleteErrorData.data }))));
};
exports.default = MetadataList;
